// extracted by mini-css-extract-plugin
module.exports = {"container":"productDetail_container__Y7aCq","text":"productDetail_text__3fCag"};